import { navLinks } from "@/mocks/homeData";

const archiveLinks = [
  { label: "起点档案", href: "#archive" },
  { label: "发酵档案", href: "#archive" },
  { label: "爆发档案", href: "#archive" },
  { label: "后续档案", href: "#archive" },
];

const formatLinks = [
  { label: "PDF 完整版", href: "#download" },
  { label: "时间线长图", href: "#download" },
  { label: "节点速查表", href: "#download" },
  { label: "课代表卡片", href: "#download" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200/70 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">超碰吃瓜</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-700">
              一份按时间先后整理的档案页。这里不做情绪判断，只把超碰吃瓜时间线的完整版全记录摆出来，
              让来龙去脉和前因后果自己说话。
            </p>
          </div>

          <div className="lg:col-span-2 lg:col-start-6">
            <h4 className="font-heading text-sm font-bold text-foreground-950">页面导航</h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">分册档案</h4>
            <ul className="mt-4 space-y-3">
              {archiveLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">下载格式</h4>
            <ul className="mt-4 space-y-3">
              {formatLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 超碰吃瓜 · 时间线档案。内容仅作信息整理与留档展示。
          </p>
          <p className="text-xs text-foreground-600">
            本站为静态展示页面，所有按钮与下载均为演示效果。
          </p>
        </div>
      </div>
    </footer>
  );
}